import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import { BrowserRouter, Route, Routes} from 'react-router-dom';
import {ScrollToHashElement} from './Utils/ScrollToHashElement.js';

import PortfolioPages from './PortfolioPages.js';
import BookList from './BookList.js';
import Gallery from '../portfolio/Gallery.js';
import Articles from './Essays_old.js';
import Videos from './Videos.js';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
          <ScrollToHashElement />
          <Routes>
            <Route exact path="/" element={<PortfolioPages />}/>
            <Route exact path="/portfolio" element={<PortfolioPages />}/>
            <Route path="/booklist" element={<BookList />} /> 
            <Route path="/videos" element={<Videos />} />
            <Route exact path="/essays" element={<Articles/>} />
            <Route exact path="/essays/:essay" element={<Articles/>} />
            <Route exact path="/gallery" element={<Gallery />}/>
          </Routes>
      </BrowserRouter>
    );
  }
}

export default App;
